import React from "react";
import PropTypes from "prop-types";

export default function StatusTags({ hold, discrepancies, underReview }) {
  return (
    <div>
      {hold && (
        <span className="label label-danger" style={{ marginRight: 10 }}>
          <i className="fa fa-pause" />
          <span className="with-padding">On Hold</span>
        </span>
      )}
      {underReview && (
        <span className="label label-warning" style={{ marginRight: 10 }}>
          <i className="fa fa-pause" />
          <span className="with-padding">Under Review</span>
        </span>
      )}
      {discrepancies && (
        <span className="label label-danger">
          <i className="fa fa-warning" />
          <span className="with-padding">Disc. Reported</span>
        </span>
      )}
    </div>
  );
}

StatusTags.propTypes = {
  hold: PropTypes.bool.isRequired,
  discrepancies: PropTypes.bool.isRequired,
  underReview: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/Receiving/components/shared/StatusTags.jsx